<template>
  <payout-limits
    :limits="limits"
    :entities="entities"
    :is-loading="isLoading"
    @reload="loadLimits"
    @save="update($event)"
    @delete="onDelete"
  />
</template>

<script>
import { API } from '@/utils/api'
import PayoutLimits from '../components/PayoutLimits.vue';

export default {
  components: {
    PayoutLimits,
  },
  data() {
    return {
      isLoading: false,
      limits: [],
      entities: [],
    }
  },
  created() {
    this.initialize()
  },
  methods: {
    initialize() {
      this.isLoading = true
      Promise.all([this.loadEntities(), this.loadLimits()]).finally(() => this.isLoading = false)
    },
    loadEntities() {
      return API.call('/users/entity_list.json').then(resp => {
        this.entities = resp.data
      })
    },
    loadLimits() {
      this.isLoading = true
      return API.call('/$v/payout_limits/list.json').then(resp => {
        this.limits = resp.data
      }).finally(() => this.isLoading = false)
    },
    update(limit) {
      this.isLoading = true
      return API.call('/$v/payout_limits/update.json', {limit}).then(resp => {
        const updatedLimit = this.limits.find(limit => limit.entity_id === resp.data.entity_id);
        updatedLimit.payout_limits = resp.data.payout_limits
      }).finally(() => this.isLoading = false)
    },
    onDelete(limit) {
      this.$root.$confirm('Confirm', 'Are you sure you want to delete this project limit?')
        .then(yes => {
          if (!yes) {
            return
          }

          this.update(limit);
        })
    },
  },
}
</script>
